import axios from 'axios';
import { apiUrl } from './index';

export default {
  getItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/networks`,
      params,
    });
  },
  getLinkedCountries() {
    return axios({
      method: 'get',
      url: `${apiUrl}/networks/link_countries`,
    });
  },
  getStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/networks/statuses`,
    });
  },
  createItem(query) {
    return axios({
      method: 'post',
      url: `${apiUrl}/networks`,
      data: query,
    });
  },
  updateItem(query) {
    const { network_id } = query;

    return axios({
      method: 'put',
      url: `${apiUrl}/networks/${network_id}`,
      data: query,
    });
  },
  updateItemStatus(query) {
    const { network, status, country } = query;

    return axios({
      method: 'put',
      url: `${apiUrl}/networks/${network.id}/status`,
      data: {
        status: status.id,
        country,
      },
    });
  },
};
